import {html, type TemplateResult} from "lit";
import {customElement} from "lit/decorators.js";
import {UnLitElement} from "../../../common/elements";
import {relativize} from "../../../common/utils/url";
import type {Nullable} from "../../../bootstrap/common/types";
import {trackingTextlinkInteract} from "../../../tracking/trackingAttributes";

@customElement("eop-lightbox-dialog-content")
export class LightboxDialogContent extends UnLitElement {

    public constructor(
        private headline: string,
        private subheadline: string,
        private url: string,
        private lightboxImageUrl: string,
        private mediaType: string,
        private imgAltText: string,
        private buttonLabel: string
    ) {
        super();
    }

    public render(): TemplateResult {
        return html`
            <div class="layer-section layer-section-background-white">
                ${this.renderHeadline()}
                ${this.renderImageElement()}
                <div class="caption">
                    ${this.renderSubheadline()}
                    ${this.renderDownloadLink()}
                </div>
            </div>
        `;
    }

    private renderHeadline(): Nullable<TemplateResult> {
        if (!this.headline) {
            return null;
        }

        return html`
            <h3 class="h">${this.headline}</h3>
        `;
    }


    private renderImageElement(): TemplateResult {
        if (this.mediaType === "responsiveImage") {
            return html`
                <eop-responsive-image
                        .imageSrc=${this.lightboxImageUrl}
                        .imageAlt=${this.imgAltText}
                        intrinsic-aspect-ratio
                ></eop-responsive-image>
            `;
        }
        return html`
            <eop-plain-image
                    src=${this.lightboxImageUrl}
                    alt=${this.imgAltText}
                    class="eop-image"
                    intrinsic-aspect-ratio
            ></eop-plain-image>
        `;
    }

    private renderSubheadline(): Nullable<TemplateResult> {
        if (!this.subheadline) {
            return null;
        }

        return html`
            <span class="caption-text">${this.subheadline}</span>
        `;
    }

    private renderDownloadLink(): TemplateResult {
        const relativeUrl = relativize(this.url);
        return html`
            <span class="image-download-link">
                <a href=${relativeUrl} download class="link media-link" ${trackingTextlinkInteract(this.buttonLabel, relativeUrl)}>${this.buttonLabel}</a>
            </span>
        `;
    }
}

export namespace LightboxDialogContentFactory {
    export function create(
        headline: string,
        subheadline: string,
        url: string,
        lightboxImageUrl: string,
        mediaType: string,
        imgAltText: string,
        buttonLabel: string
    ): LightboxDialogContent {
        return new LightboxDialogContent(headline, subheadline, url, lightboxImageUrl, mediaType, imgAltText, buttonLabel);
    }
}